import { memo, FC } from 'react'
import {
  // Select,
  InputGroup,
  // InputLeftAddon
} from '@chakra-ui/react'

import { MaskedInput } from 'components'
import { brazilianDateMask } from 'utils/masks'
import { DynamicFieldProps } from '../..'

const DateInputFilterField: FC<DynamicFieldProps> = ({
  name,
  register,
}) => {
  return (
    <InputGroup width="100%" minWidth="min-content">
      {/* <InputLeftAddon p={0} width="max-content">
        <Select placeholder="Selecione uma regra" roundedRight="none" {...register(`${name}_rule`)}>
          <option value="HAVE">Contém</option>
          <option value="NOT_HAVE">Não contém</option>
        </Select>
      </InputLeftAddon> */}
      <MaskedInput
        mask={brazilianDateMask}
        inputMode="numeric"
        {...register(name)}
      />
    </InputGroup>
  )
}

export default memo(DateInputFilterField)
